import React from 'react';
import './RoomCard.css';

const RoomCard = ({ room }) => {
  // Phone and WhatsApp numbers
  const phoneNumber = '+918019472678';
  const whatsappNumber = '918019472678';

  const renderStars = (rating) => {
    return '★'.repeat(Math.floor(rating)) + '☆'.repeat(5 - Math.floor(rating));
  };

  // Handle phone call
  const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  // Handle WhatsApp chat with room-specific message
  const handleWhatsApp = () => {
    const message = `Hi! I want to enquire about ${room.name} at AA GRAND HOTEL. Can you please share availability and pricing?`;
    window.open(
      `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`,
      '_blank'
    );
  };

  return (
    <div className="room-detail-card">
      <div className="room-detail-image">
        <img src={room.image} alt={room.name} />
        <div className="room-detail-badge">
          <span>{room.badge}</span>
        </div>
        <div className="room-detail-price">
          <span className="price">{room.price}</span>
          <span className="price-per">{room.pricePer}</span>
          {room.shortStayPrice && (
            <span className="price-short">4 Hrs - {room.shortStayPrice}</span>
          )}
        </div>
      </div>

      <div className="room-detail-content">
        <div className="room-detail-header">
          <h2 className="room-detail-name">{room.name}</h2>
          <div className="room-detail-rating">
            <span className="stars">{renderStars(room.rating || 5)}</span>
            <span className="rating-text">({room.rating || 5}/5)</span>
          </div>
        </div>

        <p className="room-detail-description">{room.description}</p>

        <div className="room-detail-specs">
          <div className="spec-item">
            <span className="spec-icon">📐</span>
            <span>{room.size}</span>
          </div>
          <div className="spec-item">
            <span className="spec-icon">🛏️</span>
            <span>{room.beds}</span>
          </div>
          <div className="spec-item">
            <span className="spec-icon">👥</span>
            <span>Max {room.maxGuests} Guests</span>
          </div>
          <div className="spec-item">
            <span className="spec-icon">💕</span>
            <span>Couple Friendly</span>
          </div>
        </div>

        <div className="room-detail-amenities">
          <h4>Room Amenities</h4>
          <div className="amenities-grid">
            {room.amenities.map((amenity, index) => (
              <span key={index} className="amenity-item">
                ✓ {amenity}
              </span>
            ))}
          </div>
        </div>

        <div className="room-detail-actions">
          <button onClick={handleCall} className="room-detail-btn primary">
            📞 Book Now
          </button>
          <button onClick={handleWhatsApp} className="room-detail-btn secondary">
             Enquire Now →
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoomCard;